module.exports = __webpack_public_path__ + "icon_cross_fat_100white.8784b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_cross_fat_100white.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_cross_fat_100white.svg
// module chunks = main